import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone_fetch_cache';

import 'jquery_cookie';

import QuestionCollection from 'screener/collections/question';
import QuestionLog from 'screener/models/question_log';
import QuestionLogCollection from 'screener/collections/question_log';
import AnswerView from 'screener/views/answer';
import ScreenerResultsView from 'screener/views/screener_results';
import date_nav from 'core/controllers/date_navigation';
import DropdownView from 'core/views/dropdown';
import LoadingView from 'core/views/loading';
import GoogleAnalytics from 'core/google_analytics';


// Screener view
export default Backbone.View.extend({
  ready: false,
  is_submitted: false,

  initialize: function (options) {
    _.bindAll(this, 'renderPanel', 'render', 'render_modal',
      'onAnswerUpdated', 'open');

    // Member variables
    this.body = $('body');
    this.loadingView = new LoadingView({ el: this.body });
    this.screener = null;
    this.modal = null;
    this.results = null;

    // Page elements
    this.panel = options && options.panel;

    // Templates
    this.modal_template = _.template($('#screener-modal-template').html());

    // Collections
    this.question_collection = new QuestionCollection();
    this.user_progress_collection = options && options.parent_view &&
                  options.parent_view.user_progress_collection;
  },

  open: function () {
    if (this.modal) {
      this.modal.modal('show');
    }
  },

  renderPanel: function () {
    if (this.user_progress_collection) {
      var user_screeners = this.user_progress_collection.where({
        screener_set_item: this.model.get('resource_uri')
      });
      if (user_screeners.length) {
        var user_screener = _.last(user_screeners);
        if (user_screener.get('completed_at')) {
          $('.btn-primary', this.panel).hide();
          $('#completed-info', this.panel).show();
          var completed_at = new Date(user_screener.get('completed_at'));
          $('#completed-on', this.panel).text(
            'Completed ' + date_nav.us_date(completed_at, false));
          $('#completed-on', this.panel).text(
            interpolate(gettext('Completed %(date)s'), {
              date: completed_at.toLocaleDateString(LANGUAGE_CODE),
            }, true)
          );
        }
      }
    }
  },

  render: function () {
    this.ready = false;
    var screener = this.model.get('screener');
    if (!screener) {
      // Prevent breakage and extra work if we have no data
      return;
    }

    // If we are rendering the mood assessment and the user has
    // taken it before, change the button to "Take Survey"
    if (screener.slug == 'depression-assessment' && this.user_progress_collection) {
      if (this.user_progress_collection.findWhere({
        screener_set_item: this.model.id
      })) {
        $('a.btn', this.panel).html('Take Survey');
      }
    }

    this.renderPanel();

    // Get the questions and render the screener modal
    if (!this.question_collection.length) {
      this.question_collection.params.screener = screener.id;
      this.question_collection.fetch({
        cache: false,
        success: this.render_modal
      });
    } else {
      // The screener has been taken, reset the modal
      $('#screener-modal-' + this.model.get('id')).remove();
      this.render_modal();
    }
    return this;
  },

  render_modal: function () {
    this.body.append(this.modal_template({
      screener_set_item: this.model,
      questions: this.question_collection.models
    }));

    this.modal = $('#screener-modal-' + this.model.get('id'));
    this.screener = $('.carousel', this.modal);
    // Enable dropdowns
    _.each($('.form-dropdown', this.screener), function (dropdown_el) {
      new DropdownView({ el: dropdown_el });
    });
    // Create answer views
    var self = this;
    self.answer_views = [];
    _.each($('.question', this.screener), function (question_el) {
      var question = self.question_collection.findWhere(
        { id: $(question_el).data('question') });
      var answer_view = new AnswerView({
        el: question_el,
        screenerSetItem: self.model,
        question: question,
        question_el: $(question_el),
        modal: self.modal
      });
      self.answer_views.push(answer_view);
      answer_view.on('answered unanswered', self.onAnswerUpdated);
    });

    // We need custom handling of the "Next" buttons, because sometimes
    // there will be two carousel items concurrently ".active"
    $('a.next-question, a.get-started', this.screener).on('click', function (e) {
      var next_btn = $(e.currentTarget);
      var active_items = $('.item.active', self.screener);
      if (active_items.length > 1) {
        e.preventDefault();
        // Deactivate other items and re-click
        active_items.not(next_btn.parent('.item')).removeClass('active');
        next_btn.click();
      }
    });

    // When done is clicked, validate answers, and either save or
    // notify
    $('button', this.screener).on('click', function (e) {
      self.is_submitted = true;
      var question_log_collection = new QuestionLogCollection();
      var valid = _.reduce(self.answer_views, function (m1, view) {
        // To save time, also gather question logs here.
        // get_question_logs gets all the question logs for the
        // question, plus adds a dummy log for checkbox-type
        // questions if necessary.
        question_log_collection.add(view.get_question_logs());
        return m1 && view.isValid();
      }, true);
      if (!valid) {
        return false;
      }
      // All questions are valid, but (for checkbox questions)
      // did the user actually check anything?
      var no_check = question_log_collection.all(function (model) {
        return typeof model.get('value') === 'undefined';
      });
      if (no_check) {
        return false;
      }
      // Sync the question log collection, then display the
      // results and trigger an event for subscribers.
      // now show loading screen
      $('#screener-modal-' + self.model.get('id')).on('hidden.bs.modal', function () {
        window.scrollTo(0, 0);
        self.loadingView.show();
      });
      Backbone.sync('patch', question_log_collection, {
        success: function () {
          self.model.fetch({ cache: false, success: self.render });

          // Display feedback
          self.results = new ScreenerResultsView({
            model: self.model.clone(),
            parentView: self
          });

          // Send submitted event
          self.trigger('submitted');
        }
      });
      // Create Google Analytics events for answers to screeners
      question_log_collection.each(function (question_log) {
        var value = Number(question_log.get('value'));
        if (_.isNaN(value)) {
          return;
        }
        var question = self.question_collection.findWhere({
          resource_uri: question_log.get('question')
        });
        if (!question) {
          return;
        }
        var screener_slug = self.model.get('screener').slug;
        var question_slug = question.get('slug');
        GoogleAnalytics.send_event(
          screener_slug, 'submitted', question_slug, value);
      });
    });
    $('a[href="#screener-modal-' + this.model.get('id') + '"]').removeClass('disabled');
    this.ready = true;
    this.trigger('ready');
  },

  onAnswerUpdated: function () {
    var question_log_collection = new QuestionLogCollection();
    var last_visible_answer = null;
    var valid = _.reduce(this.answer_views, function (m1, view) {
      if (view.question_el.is(':hidden')) {
        // Don't validate anything that's invisible
        return m1;
      }
      // To save time, also gather question logs here.
      // get_question_logs gets all the question logs for the
      // question, plus adds a dummy log for checkbox-type
      // questions if necessary.
      question_log_collection.add(view.get_question_logs());
      last_visible_answer = view;
      return m1 && view.isValid();
    }, true);

    // An extra check is needed to ensure something was checked on
    // checkbox questions
    var no_check = question_log_collection.all(function (model) {
      return typeof model.get('value') === 'undefined';
    });

    if (!valid || no_check) {
      last_visible_answer.disable_submit();
    } else {
      last_visible_answer.enable_submit();
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/views/screener.js
// module id = 71
// module chunks = 0